<template>
  <v-layout justify-space-between>
    <v-card
      class="custom-card mr-2"
      flat
      color="grey lighten-3"
      height="90"
      width="180"
    >
      <v-card-title class="pb-0 custom-title">TOTAL</v-card-title>
      <v-card-text class="pt-0">
        <strong class="amount">{{ folders.length }}</strong>
      </v-card-text>
    </v-card>
    <v-card
      class="custom-card reviews mr-2"
      flat
      height="90"
      width="180"
    >
      <v-card-title class="pb-0 custom-title">REVISÕES</v-card-title>
      <v-card-text class="pt-0">
        <strong class="amount">{{ reviews.length }}</strong>
      </v-card-text>
    </v-card>
    <v-card
      class="custom-card signatures mr-2"
      flat
      height="90"
      width="180"
    >
      <v-card-title class="pb-0 custom-title">ASSINATURAS</v-card-title>
      <v-card-text class="pt-0">
        <strong class="amount">{{ signatures.length }}</strong>
      </v-card-text>
    </v-card>
    <v-card
      class="custom-card done mr-2"
      flat
      height="90"
      width="180"
    >
      <v-card-title class="pb-0 custom-title">CONCLUÍDAS</v-card-title>
      <v-card-text class="pt-0">
        <strong class="amount">{{ done.length }}</strong>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
export default {
  name: 'pending-cards',
  props: ['folders'],
  computed: {
    reviews() {
      const reviews = this.folders.filter(item => item.pending_type === 'review');
      return reviews;
    },
    signatures() {
      const signatures = this.folders.filter(item => item.pending_type === 'signature');
      return signatures;
    },
    // TODO: Ask for API developers to return the done folders in this section
    done() {
      const done = this.folders.filter(item => item.received_status === 'done');
      return done;
    },
  },
};
</script>

<style scoped>
  .custom-card {
    border-radius: 5px;
  }
  .custom-title {
    font-size: 12px;
  }
  .amount {
    font-size: 32px;
  }
  .reviews {
    border: 1px solid #ffbd42;
    color: #ffbd42;
  }
  .signatures {
    border: 1px solid #4185f4;
    color: #4185f4;
  }
  .done {
    border: 1px solid rgba(0, 0, 0, 0.54);
    color: rgba(0, 0, 0, 0.54);
  }
</style>



// WEBPACK FOOTER //
// src/views/folder/list/pending/PendingCards.vue